import {Routes, Route, Navigate} from 'react-router';
import './App.css';
import Login from './agent/auth/login';
import Signup from './agent/auth/signup';
import Home from './agent/dash/pages/home';
import Error from './errorPage';
import Payment from './agent/dash/pages/payment';
import Properties from './agent/dash/pages/properties';
import DashboardGuard from './guards/DashboardGuard';
import PropertyDetails from './agent/dash/pages/property_details';
import UnitDetails from './agent/dash/pages/unit_details';
import EditProfile from './agent/dash/pages/edit_profile';
import Profile from './agent/dash/pages/profile';
import ResetPassword from './agent/auth/resetPassword';
import ResetPasswordToken from './agent/auth/resetPassword_token';
import Tenancy from './agent/dash/pages/tenancy';
import Tenants from './agent/dash/pages/tenants';
import Tenantinvoice from './agent/dash/pages/tenant_invoices';
import TenantDetails from './agent/dash/pages/tenant_details';


function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/Signup" />} />
      <Route path='/login' element={<Login />} />
      <Route path='/signup' element={<Signup />} />
      <Route path='/reset-password' element={<ResetPassword />} />
      <Route path='/reset-password/:token' element={<ResetPasswordToken />} />,

      <Route path='/dashboard' element={<DashboardGuard />} children={
        [
          <Route path='/dashboard/home' element={<Home />} />,
          <Route path='/dashboard/payments' element={<Payment />} />,
          <Route path='/dashboard/properties' element={<Properties />} />,
          <Route path='/dashboard/tenants' element={<Tenants />} />,
          <Route path='/dashboard/tenant/:tenantRoomId/invoice' element={<Tenantinvoice />} />,
          <Route path='/dashboard/tenant/:tenantRoomId/invoice/:invoiceTitle' element={<Tenantinvoice />} />,
          <Route path='/dashboard/tenant/:tenantId/' element={<TenantDetails />} />,
          <Route path='/dashboard/properties/:id' element={<PropertyDetails />} />,
          <Route path='/dashboard/edit_profile' element={<EditProfile />} />,
          <Route path='/dashboard/property/:propertyId/unit/:id' element={<UnitDetails />} />,
          <Route path='/dashboard/profile' element={<Profile />} />,
          // <Route path='/dashboard/tenants' element={<Tenancy />} />,
          <Route path='/dashboard/unit/:unitId/room/:id/tenants' element={<Tenancy />} />,
          // Error page
          <Route path='/dashboard/*' element={<Error />} />
        ]
      } />
      <Route path='*' element={<Error />} />
    </Routes>

  );
}

export default App;
